import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select,DatePicker,Row, Col,Image,Card, Alert, Spin, message } from 'antd';
import {onecodeAPI} from "../AppConfig";
import _ from "lodash";
import { constants } from "./constants";
import 'antd/es/spin/style/css';
import 'antd/dist/antd.css';
import moment from "moment";
import 'antd/es/spin/style/css';
import { LoadingOutlined } from '@ant-design/icons';

message.config({
  top: '25vh',
  duration: 2,
});


const antIcon = <LoadingOutlined style={{ fontSize: 18, color: '#fff', marginRight: 10 }} spin />;

const { Option } = Select;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 12,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

export default (props) => {
  const [form] = Form.useForm();
  const [userData,setUserData] = useState({});
  const [agentDetails,setAgentDetails] = useState({});
  const [loading, setLoading] = useState(false)
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const [mobileNumber,setMobileNumber] = useState("");


  let params = new URLSearchParams(window.location.search);
  let hash= params.get('token');

  useEffect(()=>{
    if(props.location.pathname == "/agentdetails"){
      getAgentDetails();
  }else if(props.location.pathname == "/agentcustomerdetails" ){
      getUserData();
  }
  },[])

const getAgentDetails = async () => {
  try {
    setLoading(true)
    const resp = await onecodeAPI.get(`/public/api/agentdetails?token=${hash}`);
    setLoading(false)
    setAgentDetails(resp.data.data)
  } catch (error) {
    setLoading(false)
    alert("Error",error);
  }
}


    const getUserData = async () => {
      try {
        setLoading(true)
        const resp = await onecodeAPI.get(`/public/api/agentcustomerdetails?token=${hash}`)
        setLoading(false)
        let responseData = resp.data.data;
        setAgentDetails(responseData.agent);
        setUserData(responseData.customer);
        // console.log("responseData=====", responseData);
        setMobileNumber(responseData.customer.phoneNumber)
        form.setFieldsValue({
          ...responseData.customer,
          dob: responseData?.customer?.dob ? moment(responseData.customer.dob) : null,
        });
        
      } catch (error) {
        setLoading(false)
        alert("Error",error);
      }
    }

    const updateUserData = async (userData) => {
      try {
        setFormSubmitLoading(true)

        // console.log("userData=========", {...userData, dob: userData.dob.format("YYYY-MM-DD")});
        
        const resp = await onecodeAPI.put(`/public/api/updateCustomer?token=${hash}`,{...userData, dob: userData?.dob?.format("YYYY-MM-DD") || null})
        setFormSubmitLoading(false)
        if(resp.status == 200){
          message.success("Details successfully updated")
        }
      } catch (error) {
        setFormSubmitLoading(false)
        message.error("Failed to submit details")      }
  }

  const postUserData = async (userData) => {
      try {
        setFormSubmitLoading(true)
        const resp = await onecodeAPI.post(`/public/api/addcustomer?token=${hash}`,{...userData, dob: userData?.dob?.format("YYYY-MM-DD") || null})
        setFormSubmitLoading(false)
        if(resp.status == 200){
          message.success("Details successfully submitted")
        }
      } catch (error) {
        setFormSubmitLoading(false)
        message.error("Failed to submit details")      }
  }


  const onFinish = (values) => {
    if(props.location.pathname == "/agentdetails"){
          postUserData(values)
      }else if(props.location.pathname == "/agentcustomerdetails" ){
          updateUserData(values);
      }
  };


  return (

        <Row>
          
          <div style = {{padding : "10px 20px"}}>
          <Spin spinning = {loading}>
              <div style={{ display : "flex",flexDirection : "row",padding : 10,backgroundColor : "#F0F0F0",borderRadius :10,marginBottom : 20,marginTop : 10}}>
                  <Image 
                    width={60}
                    height = {60}
                    style = {{borderRadius : 100,marginTop : 5}}
                    preview={false}
                    src={agentDetails?.profileLink || "/placeholder.png"}
                  />
                  <div style = {{marginLeft : 10}}>
                      <p style = {{marginBottom : 0,color : "#757575",fontSize : 12}}>Advisor</p>
                      <p style = {{marginBottom : 0,fontWeight : "bold",fontSize : 16}}>{agentDetails.name}</p>
                      <p style = {{marginBottom : 0,fontWeight : "bold",color : "#6c63ff"}}>{agentDetails.phone}</p>
                  </div>
              </div>
            <Form form={form} name="control-hooks" onFinish={onFinish}>
              <Form.Item
                name="fullName"
                rules={[
                  {
                    required: true,
                    message: 'Please enter your name',
                  },
                ]}
                style = {{borderRadius : 10}}
              >
                <Input size = "large" 
                  placeholder="Full Name" 
                  style = {{borderRadius : 6}}
                  />
              </Form.Item>
              <Form.Item
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Phone Number',
                  },
                ]}
              >
                <Input size = "large" placeholder="Phone Number" disabled = { mobileNumber != "" ? true : false } style = {{borderRadius : 6}}/>
              </Form.Item>
              <Form.Item
                name="email"
              >
                <Input size = "large" 
                  placeholder="Email" 
                  style = {{borderRadius : 6}}
                  />
              </Form.Item>
              <Form.Item
                name="gender"
              >
                <Select
                  placeholder="Select Gender"
                  allowClear
                >
                  <Option value="male">male</Option>
                  <Option value="female">female</Option>
                  <Option value="other">other</Option>
                </Select>
              </Form.Item>
              <Form.Item 
                name="dob"
                >
                  <DatePicker 
                  placeholder="Enter Date of Birth (DD-MM-YYYY)"
                  style={{ width: 280}} 
                  format="DD-MM-YYYY"/>
              </Form.Item>
              <Form.Item
                name="panNo"
              >
                <Input size = "large" placeholder="PAN Number" style = {{borderRadius : 6}}/>
              </Form.Item>
              <Form.Item
                name="education"
              >
                <Select
                  placeholder="Choose your Qualification"
                  allowClear
                >
                  { constants.qualifications.map((q) => 
                      <Option key= {q} value={q}>{q}</Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="currentOccupation"
              >
                <Select
                  placeholder="What work you do ?"
                  allowClear
                >
                  { constants.occupation.map( (list,key) => 
                      <Option key= {key} value={list.value}>{list.label}</Option>
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="annualIncome"
              >
                <Select
                  placeholder="Annual Income"
                  allowClear
                >
                  { constants.annualIncome.map((q) => 
                      <Option key= {q} value={q}>{q}</Option>
                  )}
                </Select>
              </Form.Item>
              {/* <Form.Item
                name="annualIncome"
              >
                <Input size = "large" placeholder="Monthly Salary" style = {{borderRadius : 6}} />
              </Form.Item> */}
              <Form.Item
                name="address"
              >
                <Input size = "large" placeholder="Address" style = {{borderRadius : 6}} />
              </Form.Item>
              <Form.Item
                name="pinCode"
              >
                <Input size = "large" placeholder="Pincode" style = {{borderRadius : 6}} />
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                {formSubmitLoading && <Spin indicator={antIcon} />}
                  Submit
                </Button>
              </Form.Item>
            </Form>
            </Spin>
    </div>

    </Row>
  );
};